export const playNextPreviousMedia = ({
  medias: { data },
  showPlayer,
  updateLastPlayed,
  setActiveMedia,
  nextOrPrevious,
  mediaId,
}) => {
  const currentMediaIndex = data.findIndex(
    (media) => media.mediaId === mediaId
  );
  let nextMedia = {};
  if (nextOrPrevious === "next") {
    if (currentMediaIndex < data.length - 1) {
      nextMedia = data[currentMediaIndex + 1];
    } else {
      nextMedia = data[0];
    }
  }
  if (nextOrPrevious === "previous") {
    if (currentMediaIndex > 0) {
      nextMedia = data[currentMediaIndex - 1];
    } else {
      nextMedia = data[data.length - 1];
    }
  }

  if (!nextMedia) return;
  showPlayer(nextMedia.mediaId);
  updateLastPlayed(nextMedia.mediaId);
  setActiveMedia(nextMedia.mediaId);
};

export default playNextPreviousMedia;
